import React, { useState } from 'react';
import {
  TextField,
  Button,
  Paper,
  Typography,
  Grid,
  MenuItem,
  Switch,
  FormControlLabel
} from '@material-ui/core';
import api from './api';
import { toast } from 'react-toastify';

const orientationOptions = [
  { value: 'right', label: 'Right' },
  { value: 'left', label: 'Left' },
  { value: 'noshow', label: 'No Show' },
];

const CrouselsManager = ({ refetch, siteData }) => {
 
 const MAX_CROUSELS=5
 
 
  const s3_site_url = 'https://d6-halo.s3.us-east-2.amazonaws.com/static/media/crousels/';

  const [carousels, setCarousels] = useState(
    siteData?.crousels?.length
      ? siteData.crousels.map((crous) => ({
          id: crous.id || null,
          site: siteData?.ID,
          heading: crous.heading || '',
          subHeading: crous.subHeading || '',
          moreInfo: crous.moreInfo || '',
          orientation: crous.orientation || 'right',
          image: crous.imageN || null,
          imagePreview: crous.imageN ? s3_site_url + crous.imageN : null,
          active: crous.active ?crous.active :false
        }))
      : [
          {
            site: siteData?.ID,
            heading: '',
            subHeading: '',
            moreInfo: '',
            orientation: 'right',
            image: null,
            imagePreview: null,
            active: true,
          },
        ]
  );
const [processing,setProcessing]=useState(false)
 
const [active,setActive]=useState('')


const handleChange = (index, e) => {
    const { name, value, type, files, checked } = e.target;
    const updated = [...carousels];

    if (type === 'file') {
      const file = files[0];
      updated[index][name] = file;
      updated[index].imagePreview = URL.createObjectURL(file);
    } else if (type === 'checkbox') {
      updated[index][name] = checked;
    } else {
      updated[index][name] = value;
    }

    setCarousels(updated);
  };

  const handleAddCarousel = () => {

    if(carousels.length<MAX_CROUSELS){
    setCarousels([
      ...carousels,
      {
        site: siteData?.ID,
        heading: '',
        subHeading: '',
        moreInfo: '',
        orientation: 'right',
        image: null,
        imagePreview: null,
        active: true,
      },
    ]);}else{
      toast.error(`Max ${MAX_CROUSELS} carousel slides are allowed`)
    }
  };

 const handleSubmit = async (index) => {
  const formData = new FormData();
  const carousel = carousels[index];
setActive(index)

 const requiredFields = ['heading', 'subHeading', 'moreInfo'];
  const missingFields = requiredFields.filter((field) => !carousel[field]?.toString().trim());
if (missingFields.length > 0) {
    toast.error(`Carousel #${index + 1}: Please fill ${missingFields.join(', ')}`);
    return;
  }
   if (!carousel.id && (!carousel.image || !carousel.image.name)) {
      toast.error(`Carousel #${index + 1}: Image is required`);
      return;
    }
  
  Object.entries(carousel).forEach(([key, value]) => {
    if (key === 'imagePreview') return;

    if (key === 'image') {
      if (value && value.name) {
        formData.append('image', value);
      }
    } else {
      if (value !== null && value !== undefined) {
        formData.append(key, value);
      }
    }
  });

  try {

    setProcessing(true)
    if (carousel.id) {

      formData.append('id', carousel.id);
      await api.put('crousel-v2', formData);
      toast.success(`Carousel #${index + 1} updated`);
    } else {
      await api.post('crousel-v2', formData);
      toast.success(`Carousel #${index + 1} created`);
    }
setProcessing(false)
    refetch?.();
  } catch (err) {
    console.error(err);
    setProcessing(false)

    toast.error(
      `Error ${carousel.id ? 'updating' : 'creating'} carousel #${index + 1}`
    );
  }
};


  return (
    <Paper style={{ padding: 20 }}>
      <Typography variant="h6">Manage Carousels</Typography>

      {carousels.map((carousel, index) => (
        <Paper key={index} style={{ padding: 16, marginBottom: 20, background: '#f9f9f9' }}>
          <Typography variant="subtitle1">Carousel #{index + 1}</Typography>
          <Grid container spacing={2}>
            {/* Active Switch */}
            <Grid item xs={12} style={{ textAlign: 'right' }}>
              <FormControlLabel
                control={
                  <Switch
                    checked={carousel.active}
                    onChange={(e) => handleChange(index, e)}
                    name="active"
                    color="primary"
                  />
                }
                label="Active"
              />
            </Grid>

            {/* Heading */}
            <Grid item xs={12} sm={6}>
              <TextField
                fullWidth
                label="Heading"
                name="heading"
                value={carousel.heading}
                onChange={(e) => handleChange(index, e)}
              />
            </Grid>

            {/* Sub Heading */}
            <Grid item xs={12} sm={6}>
              <TextField
                fullWidth
                label="Sub Heading"
                name="subHeading"
                value={carousel.subHeading}
                onChange={(e) => handleChange(index, e)}
              />
            </Grid>

            {/* More Info */}
            <Grid item xs={12}>
              <TextField
                fullWidth
                multiline
                rows={3}
                label="More Info"
                name="moreInfo"
                value={carousel.moreInfo}
                onChange={(e) => handleChange(index, e)}
              />
            </Grid>

            {/* Orientation Dropdown */}
            <Grid item xs={12} sm={6}>
              <TextField
                select
                fullWidth
                label="Orientation"
                name="orientation"
                value={carousel.orientation}
                onChange={(e) => handleChange(index, e)}
              >
                {orientationOptions.map((option) => (
                  <MenuItem key={option.value} value={option.value}>
                    {option.label}
                  </MenuItem>
                ))}
              </TextField>
            </Grid>

            {/* Image Upload */}
            <Grid item xs={12}>
              <input
                type="file"
                name="image"
                accept="image/*"
                onChange={(e) => handleChange(index, e)}
              />
            </Grid>

            {/* Image Preview */}
            {(carousel.imagePreview ||
              (typeof carousel.image === 'string' && carousel.image)) && (
              <Grid item xs={12}>
                <img
                  src={
                    carousel.imagePreview
                      ? carousel.imagePreview
                      : s3_site_url + carousel.image
                  }
                  alt={`Preview #${index + 1}`}
                  style={{ maxWidth: '100%', maxHeight: 200, marginTop: 10 }}
                />
              </Grid>
            )}

            {/* Submit Button */}
            <Grid item xs={12}>
              <Button
                variant="contained"
                color="primary"
                onClick={() => handleSubmit(index)}
              >
                {active===index&&processing?"Updating": carousel.id ? 'Update' : 'Create'} Carousel #{index + 1}
              </Button>
            </Grid>
          </Grid>
        </Paper>
      ))}

      {/* Add New Carousel */}
      <Button variant="contained" color="primary" onClick={handleAddCarousel}>
        + Add Carousel
      </Button>
    </Paper>
  );
};

export default CrouselsManager;
